import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DashboardService } from 'app/dashboard/dashboard.service';

@Component({
  selector: 'app-labentry-panel',
  templateUrl: './labentry-panel.component.html',
  styleUrls: ['./labentry-panel.component.scss']
})
export class labEntryPanelComponent implements OnInit {
  DynamicLinks: any;
  urlArray: any = [];

  constructor(private dashboardService:DashboardService,
     public dialogRef: MatDialogRef<labEntryPanelComponent>
  ) {
      this.urlArray= [ 
        {
          level: "Laboratory Modules",
          rotelink: [
            { rname: "Sample Collection", rlink: "../labentry/samplCollection" },
            {rname:"Sample Receiving" ,rlink:"../labentry/sampleReceving"},
            { rname: "Laboratory Entry", rlink: "../labentry/testresultentry" },
            { rname: "Test Result Approval", rlink: "../labentry/testresultapproval" },
          ],
        },
        {
          level: "Daily Expenses Details",
          rotelink: [
            { rname: "Daily Expenses Details", rlink: "../labentry/dailyexpensesdetails" },
          ],
        },
    ]
  }

  ngOnInit(): void {
  }

  changepanel(titlename:any){
    this.dashboardService.reportTitle=titlename;
    this.dialogRef.close();
  }
}
